module.exports = __webpack_public_path__ + "img/header-sm.26c24240.png";